import React from 'react'
import {
  AUDIT_RESULT,
  AuditReadinessRecord,
  AuditReadinessTestRecord,
} from '@trustero/trustero-api-web/lib/audit/auditbot_pb'
import { AuditBotNotScannedIcon } from 'src/pages/AuditBot/AuditBot.styles'
import {
  CHECK_RESULT_TYPE,
  getCheckResult,
  getCheckResultIcon,
} from 'src/pages/AuditBot/accordion/subsection/ControlChecks/AuditBotControlChecks.helpers'

export const getRoadmapModalTitle = (name: string): string => {
  return `${name}: Select Controls`
}

export const getAuditReadinessIcon = (
  check: AuditReadinessRecord,
): JSX.Element => {
  if (!check.getControlTestsList().length) return <AuditBotNotScannedIcon />
  const results = check.getControlTestsList().map((test) => test.getResult())
  return getCheckResultIcon(getCheckResult(results), CHECK_RESULT_TYPE.OVERALL)
}

export const getPercentScanned = (
  records: AuditReadinessTestRecord[],
): number => {
  const total = records.length
  let scanned = 0
  records.forEach((record) => {
    if (record.getResult() !== AUDIT_RESULT.NOT_RUN) scanned++
  })
  return Math.round((scanned / total) * 100)
}
